export interface ReviewDocumentSource {
  readonly id: string;
  readonly mediaType: string;
  readonly text: string;
}

export const REVIEW_DOCUMENT_SOURCES: readonly ReviewDocumentSource[] = [
  {
    id: 'source-clinical-summary',
    mediaType: 'text/plain',
    text: 'Synthetic clinical summary\n\nEmergency physician services were provided on August 2, 2026. This review-only document contains no real patient information.',
  },
  { id: 'source-plan-response', mediaType: 'text/plain', text: 'Synthetic plan response\n\nThe plan supports its submitted offer using the supplied QPA and permitted case-specific factors.' },
];
